import axiosClient from "./axiosClient";
import {Result} from "./types";
import {getTokenCookie} from "../libs";

export class ReportApi {
    config: any

    constructor() {
        const token = getTokenCookie()
        this.config = {
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        }
    }

    getActiveReader = async (startDate: string, endDate: string, page: string): Promise<Result> => {
        return await axiosClient.get(`/reporting/activeReader/${startDate.replace('-', '')}/${endDate.replace('-', '')}/${page}`, this.config)
    }
    getActiveReaderFilterByProdi = async (startDate: string, endDate: string, page: string, value: string): Promise<Result> => {
        return await axiosClient.get(`/reporting/activeReader/filterByProdi/${startDate.replace('-', '')}/${endDate.replace('-', '')}/${page}?value=${value}`, this.config)
    }

    getLoan = async (startDate: string, endDate: string, page: string): Promise<Result> => {
        return await axiosClient.get(`/reporting/loan/${startDate.replace('-', '')}/${endDate.replace('-', '')}/${page}`, this.config)
    }
    getLoanFilterByProdi = async (startDate: string, endDate: string, page: string, value: string): Promise<Result> => {
        return await axiosClient.get(`/reporting/loan/filterByProdi/${startDate.replace('-', '')}/${endDate.replace('-', '')}/${page}?value=${value}`, this.config)
    }


    getPopularEbook = async (startDate: string, endDate: string, page: string): Promise<Result> => {
        return await axiosClient.get(`/reporting/popularBook/${startDate.replace('-', '')}/${endDate.replace('-', '')}/${page}`, this.config)
    }
    getPopularEbookFilterBySubject = async (startDate: string, endDate: string, page: string, value: string): Promise<Result> => {
        return await axiosClient.get(`/reporting/popularBook/filterBySubject/${startDate.replace('-', '')}/${endDate.replace('-', '')}/${page}?value=${value}`, this.config)
    }

    getSummaryBook = async (startDate: string, endDate: string, page: string): Promise<Result> => {
        return await axiosClient.get(`/reporting/summaryBook/${startDate.replace('-', '')}/${endDate.replace('-', '')}/${page}`, this.config)
    }

    getWaitingList = async (startDate: string, endDate: string, page: string): Promise<Result> => {
        return await axiosClient.get(`/reporting/waitingList/${page}`, this.config)
    }

    getWaitingListFilterBySubject = async (startDate: string, endDate: string, page: string,value: string): Promise<Result> => {
        return await axiosClient.get(`/reporting/waitingList/filterBySubject/${page}?value=${value}`, this.config)
    }

    getPapers = async (startDate: string, endDate: string): Promise<Result> => {
        return await axiosClient.get(`/reporting/papersReport/${startDate.replace('-', '')}/${endDate.replace('-', '')}`, this.config)
    }
    getPaperFilterBySubject = async (startDate: string, endDate: string, value: string): Promise<Result> => {
        return await axiosClient.get(`/reporting/papersReport/filterBySubject/${startDate.replace('-', '')}/${endDate.replace('-', '')}?value=${value}`, this.config)
    }

    getDashboard = async (startDate: string, endDate: string): Promise<Result> => {
        return await axiosClient.get(`/reporting/dashboard/${startDate.replace('-', '')}/${endDate.replace('-', '')}`, this.config)
    }

    getDashboardLoan = async (startDate: string, endDate: string,value: string): Promise<Result> => {
        return await axiosClient.get(`reporting/dashboard/totalLoanedBook/filterBySubject/${startDate.replace('-', '')}/${endDate.replace('-', '')}?value=${value}`, this.config)
    }
    getDashboardMemberType = async (startDate: string, endDate: string,value: string): Promise<Result> => {
        return await axiosClient.get(`reporting/dashboard/loginActivity/filterByMemberType/${startDate.replace('-', '')}/${endDate.replace('-', '')}?value=${value}`, this.config)
    }

    getNotification = async (): Promise<Result> => {
        return await axiosClient.get(`/notification/view`, this.config)
    }

    getGroup = async (): Promise<Result> => {
        return await axiosClient.get(`/group/all`, this.config)
    }
}
